<template>
    <div class="flex-col content-between flex-shrink-0 hidden h-full pb-4 md:flex bg-apps-sidebar w-apps-sidebar z-99">
        <div class="flex-1">
            <div class="flex justify-center w-full py-2 mb-2 bg-apps-sidebar-dark">
                <a :href="$store.state.user.links.account" class="flex items-center justify-center w-12 h-12 rounded-full hover:bg-apps-sidebar">
                    <div class="relative flex justify-center w-full">
                        <i class="text-xl fas fa-th text-slate-200" />
                    </div>
                </a>
            </div>
            <div class="flex justify-center w-full px-1" :key="app.key" v-for="app in availableApps">
                <a
                    :href="app.url"
                    class="flex items-center justify-center w-12 h-12 mb-1 rounded-full hover:bg-apps-sidebar-dark"
                    :class="{'bg-apps-sidebar-active': $spa.isCurrentApp(app.key)}"
                    :key="app.key"
                    :data-tooltip="app.name"
                    data-tooltip-location="right"
                >
                    <div class="relative flex justify-center w-full">
                        <img class="h-7" :src="app.icon" alt="App icon" />
                        <div class="absolute flex justify-center w-full -mt-2 top-full" v-if="! app.available">
                            <span class="font-semibold text-white uppercase rounded bg-trustup" style="padding: 3px; line-height: 10px; font-size: 10px;">{{ $t('apps_sidebar.app_not_available') }}</span>
                        </div>
                    </div>
                    <!-- <span class="block mt-1 text-base font-thin text-center text-gray-700">{{ app.name }}</span> -->
                </a>
            </div>
        </div>
        <div class="px-1" v-if="$store.state.user">
            <div class="flex justify-center w-full mb-2">
                <a target="_blank" :data-tooltip="$t('apps_sidebar.account')" data-tooltip-location="right" :href="$store.state.user.links.account" class="flex items-center justify-center w-8 h-8 rounded-full bg-slate-400 hover:bg-white">
                    <i class="text-base fas fa-user text-apps-sidebar" />
                </a>
            </div>
            <div class="flex justify-center w-full">
                <a target="_blank" :data-tooltip="$t('apps_sidebar.help')" data-tooltip-location="right" :href="$store.state.user.links.help" class="flex items-center justify-center w-8 h-8 rounded-full bg-slate-400 hover:bg-white">
                    <i class="text-base fas fa-question text-apps-sidebar" />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            availableApps()
            {
                return this.$spa.apps.filter(app => {
                    return app.displayed && app.available;
                });
            }
        }
    }
</script>